import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 加载语言文件
const requireContext = require.context('./', false, /\.js$/)
const modules = requireContext.keys().reduce((acc, key) => {
  const lang = key.replace('./', '').replace('.js', '')
  // 跳过 index.js 文件
  if (lang !== 'index') {
    acc[lang] = requireContext(key).default
  }
  return acc
}, {})

// 从 localStorage 获取保存的语言设置，默认为中文
const savedLang = localStorage.getItem('language') || 'zh'

// 创建 i18n 实例
const i18n = new VueI18n({
  locale: savedLang, // 默认语言
  fallbackLocale: 'en',
  messages: modules
})

export default i18n